import "./TradeSimulationResultComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit, IScope} from "angular";
import {SimulationCalculationRecord} from "../../models/TradeSimulationRecords";
import {Observable, ReplaySubject, Subject} from "rxjs";
import {Simulation} from "../../models/Simulation";
import {SimulationDates} from "../../models/SimulationDates";
import {ObjectUtil} from "../../../js/util/ObjectUtil";
import {TradeSimulatorViewStore} from "../../service/TradeSimulatorViewStore";
import {SimulationCalculationResult} from "../../models/SimulationCalculationResult";

export const SimulationResult = "tfTradeSimulationResult";

export function simulationResult(): IComponentOptions {
    return {
        templateUrl: "app/trade-simulator/components/simulation-result/TradeSimulationResultComponent.html",
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: TradeSimulationDataComponentController
    };
}

export class TradeSimulationDataComponentController implements IOnInit, IOnDestroy {

    public viewStore: TradeSimulatorViewStore;
    public simulation: Simulation;

    public chartData: Array<SimulationCalculationRecord> | null;
    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private $scope: IScope) {

    }

    public $onInit(): void {
        Observable.combineLatest(this.viewStore.currentDate, this.viewStore.currentResults)
                  .takeUntil(this.destroyed$)
                  .withLatestFrom(this.viewStore.dateRange)
                  .debounceTime(200)
                  .subscribe(([[date, results], dateRange]) => this.updateData(results, date, dateRange));
    }

    private updateData(results: SimulationCalculationResult | null,
                       selectedDate: string | null,
                       dateRange: SimulationDates) {
        if (results == null) {
            this.chartData = null;
        } else {
            if (selectedDate != null) {
                const data = results.summaries.filter(s => s.asAt.localeCompare(selectedDate) <= 0);
                const fakedData = this.createMissingData(data, selectedDate, dateRange);
                this.chartData = data.concat(fakedData);
            }
        }
        this.$scope.$applyAsync();
    }

    private createMissingData(chartData: Array<SimulationCalculationRecord>,
                              selectedDate: string,
                              dateRange: SimulationDates): Array<SimulationCalculationRecord> {
        const dataDates = chartData.map(d => d.asAt);
        const lastDataDate = dataDates[dataDates.length - 1];
        const rangeDates = dateRange.dates;
        const datesWithoutData = rangeDates.filter(rd => !dataDates.includes(rd))
                                           .filter(rd => rd.localeCompare(lastDataDate) >= 0)
                                           .filter(rd => rd.localeCompare(selectedDate) <= 0);
        const lastDataPoint = chartData[chartData.length - 1];
        return datesWithoutData.map(d => ObjectUtil.merge({}, lastDataPoint, {asAt: d}));
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
